import { useTranslation } from "react-i18next";
import commonContent from "../../../content/common";

export const useLeafVolumeLabel = () => {
  const { t } = useTranslation(["common"]);

  return (volumeType: string) => {
    let label = "";
    switch (volumeType) {
      case "personalTransaction":
      case "member":
        label = t("pcpv", commonContent["pcpv"] as string).toString();
        break;
      case "personalActivityPv":
      case "annualPAPV":
      case "personalActivityTransaction":
        label = t("papv", commonContent["papv"] as string).toString();
        break;
      case "group":
        label = t("gpv", commonContent["gpv"] as string).toString();
        break;
      case "personal":
        label = t("ppv", commonContent["ppv"] as string).toString();
        break;
      case "ruby":
        label = t("ruby", commonContent["ruby"] as string).toString();
        break;
      case "vcspv":
      case "vcs":
        label = t("vcspv", commonContent["vcspv"] as string).toString();
        break;
      case "ratioOfVcsToPpvPersonalOts(100%-OtsPercent(bonusAward552)":
        label = t("vcs", commonContent["vcs"] as string).toString();
        break;
      default:
        break;
    }
    return label;
  };
};
